import { useQuery } from "@tanstack/react-query";
import { getFetch } from "config/fetch";
import { baseURL } from "constants/baseUrl";
import * as queryKeys from "utils/queryKeys";
import { generateUrlString } from "./utils/generateUrlString";
const getChartRequest = async (params) =>
  await getFetch(`${baseURL}/transactions/metrics?${params}`);

export const useGetChartQuery = (params) => {
  const queryParams = generateUrlString(params);
  return useQuery({
    queryFn: () => getChartRequest(queryParams),
    queryKey: [queryKeys.Chart, { queryParams }],
    // select: (data) => console.log(data),
  });
};
